import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'

import { localize } from 'helpers/translator'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import BodymovinSegments from 'components/bodymovin/bodymovin_segments'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import adminOnboardingActions from 'redux/actions/adminOnboardingActions'
import adminOnboardingOfferTitleSelector from 'redux/selectors/admin_onboarding/admin_onboarding_offer_title_selector'

import icon from 'assets/views/admin_onboarding/clock.svg'

const segments = {
	start: {segment: [[0, 142], [142, 349]], loop: true},
	exit: {segment: [349, 372], loop: false},
}

class NoDMInformation extends PureComponent {

	constructor() {
		super()
		this.state = {
			componentStatus: 'init',
		}
		this.shareListeners = {
			onLoaded: this.startAnimation.bind(this),
			onComplete: this.animationCompleted.bind(this),
		}
	}

	startAnimation() {
		this.setState({
			componentStatus: 'start',
		})
	}

	animationCompleted() {
		this.props.animationCompleted()
	}

	createAsset() {
		return (
			<BodymovinSegments
				settings={{
					path: '/assets/media/animations/confirm.json',
				}}
				segments={segments}
				segment={this.state.componentStatus}
				listeners={this.shareListeners}
			>
				<div style={{
					width: '100%',
					height: '100%',
				}}></div>
			</BodymovinSegments>
		)
	}

	render() {
		return (
			<FullOverlay
				notificationIcon={icon}
				notificationText={this.props.offerTitle}
				title={localize('admin_onboarding_nodminformation_title')}
				strongTitle={localize('admin_onboarding_nodminformation_strong_title')}
				assetSource={this.createAsset()}
				assetWidth='391px'
				assetHeight='180px'
				primaryTextButton={localize('admin_onboarding_nodminformation_primary_text_button')}
				secondaryTextButton={localize('admin_onboarding_nodminformation_secondary_text_button')}
				primaryActionHandler={this.props.actions.referContactAction}
				secondaryActionHandler={this.props.actions.goToMyLibraryAction}
			/>
		)
	}
}

function mapStateToProps(state) {
	return adminOnboardingOfferTitleSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		referContactAction: adminOnboardingActions.noDMInformationReferContact,
		goToMyLibraryAction: adminOnboardingActions.noDMInformationGoToMyLibrary,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(NoDMInformation, null, { allowMultiple: true }))
